// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Header {\n  background-color: var(--color-primary);\n}\n.Header__back_button {\n  color: var(--color-white);\n}\n.Header__text {\n  font-weight: 500;\n  font-size: 19px;\n}\n.Header__client_logo {\n  max-width: 148px;\n  max-height: 39px;\n  height: auto;\n}\n.Header__content {\n  max-width: 1078px;\n  margin: auto;\n}\n.opacity-0 {\n  opacity: 0;\n}", ""]);
// Exports
module.exports = exports;
